import Button from './Button';
import Input from './FormInput';
import styles from './LoginForm.module.scss';
import FormMessage from './FormMessage/FormMessage';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { login } from '../redux/actions/authActions';
import { useDispatch } from 'react-redux';

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setErrorMessage] = useState(null);
 
  const validationSchema = Yup.object().shape({
    email: Yup.string().required(),
    password: Yup.string().required(),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const data = await dispatch(login(values));
        setLoading(false);
        setErrorMessage(null);
        const token = data.payload.accessToken;
        if (token) {
          await localStorage.setItem('token', JSON.stringify(token));
        } else {
          localStorage.removeItem('token');
        }
        navigate('/dashboard');
      } catch (error) {
        setLoading(false);
        console.log("LOGIN ERROR:", error);
        const errorMessage =
          error?.message ||
          'There was an error. Please try again later';
        setErrorMessage(errorMessage);
      }
    }
  });



  return (
    <>
      <form className={styles['login-form-container']} onSubmit={formik.handleSubmit}>
        <div className={styles['login-form-inner-container']}>
          <div className={styles['login-form-header']}>
            <h3>Practice Admin</h3>
          </div>
          <FormMessage message={error} />

          <div className={styles['login-form-input-container']}>
            <div className={styles['input-column']}>
              <Input
                label="Email Address"
                type="text"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                hasError={!!formik.errors.email}
              />
            </div>
            <div className={styles['input-column']}>
              <Input
                label="Password"
                type="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                hasError={!!formik.errors.password}
              />
            
            </div>
            <div className={styles['login-form-button-container']}>
              <Button
                label="Sign In"
                type="submit"
                disabled={!formik.isValid}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginForm;